// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 2/22/2024 6:36:05 AM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { CompanyToggleTypeEnum, PrintStockTypeEnum, TimeSheetFormatTypeEnum } from '../schema/Schema';
import { ContentTemplateTypeEnum, NotificationRoleInterface } from '../../../notification/models/schema/Schema';
import { Post } from '../../../httpClient';

export enum PersistCompanySettingsEnum {
  companyIdIsRequired = 0,
}

export enum GetCompanySettingsEnum {
  companyIdIsRequired = 0,
}

export enum PersistLogIdEnum {
  companyIdInvalid = 0,
  logoIdInvalid = 1,
}

export enum PersistCompanyNotificationSettingsEnum {
  companyIdIsRequired = 0,
  notifyLimitPayrollVarianceShouldBeGreaterThanZero = 1,
  minimumOneRoleRequired = 2,
}

export enum GetCompanyNotificationSettingsEnum {
  companyIdIsRequired = 0,
}

export enum GetFirmNotificationSettingsEnum {
  companyIdIsRequired = 0,
}

export enum PersistFirmNotificationSettingsEnum {
  companyIdIsRequired = 0,
}

export enum GetProcessingTimelineSettingsEnum {
  companyIdIsRequired = 0,
}

export enum PersistProcessingTimelineSettingsEnum {
  companyIdIsRequired = 0,
}

export enum TimelineChangeTypeEnum {
  notDefined = 0,
  permanent = 1,
  temporary = 2,
}

export interface PersistCompanySettingsRequestInterface {
  affectedAutoRunPayGroups?: Array<string>;
  companySettings: CompanySettingsInterface;
}

export interface PersistCompanySettingsResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetCompanySettingsRequestInterface {
  companyId: number;
}

export interface GetCompanySettingsResponseInterface {
  companySettings: CompanySettingsInterface;
  validationResults: ValidationResultsInterface;
}

export interface CompanySettingsInterface {
  id: number;
  companyId: number;
  logoId?: number;
  logoUploadDate?: string;
  timeSheetFormatType: TimeSheetFormatTypeEnum;
  printStockType: PrintStockTypeEnum;
  useLogoAsFavicon: boolean;
  approvalProcess: ApprovalProcessInterface;
  companyToggleList: Array<CompanyToggleInterface>;
}

export interface CompanyToggleInterface {
  id: number;
  companyToggleType: CompanyToggleTypeEnum;
  isOn: boolean;
  createdDate: string;
  updatedDate?: string;
  isLocked: boolean;
}

export interface ApprovalProcessInterface {
  id: number;
  priorityOneSecurityAccountId?: number;
  priorityTwoSecurityAccountId?: number;
  priorityOneUserName: string;
  priorityTwoUserName: string;
  hasPartnerEnforced2sa: boolean;
}

export interface PersistLogoIdRequestInterface {
  companyId: number;
  logoId: number;
  useLogoAsFavicon: boolean;
}

export interface PersistLogoIdResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetCompanyNotificationSettingsRequestInterface {
  companyId: number;
}

export interface GetCompanyNotificationSettingsResponseInterface {
  notifyLimitPayrollVariance: number;
  isTwoStepApprovalOn: boolean;
  companyNotificationSettingsList: Array<CompanyNotificationSettingsInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PersistCompanyNotificationSettingsRequestInterface {
  notifyLimitPayrollVariance: number;
  companyId: number;
  companyNotificationSettingsList: Array<CompanyNotificationSettingsInterface>;
}

export interface PersistCompanyNotificationSettingsResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface CompanyNotificationSettingsInterface {
  id: number;
  contentTemplateType: ContentTemplateTypeEnum;
  doNotify: boolean;
  name: string;
  description: string;
  notificationRoleList: Array<NotificationRoleInterface>;
}

export interface GetFirmNotificationSettingsRequestInterface {
  companyId: number;
}

export interface GetFirmNotificationSettingsResponseInterface {
  companyNotificationSettingsList: Array<CompanyNotificationSettingsInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PersistFirmNotificationSettingsRequestInterface {
  companyId: number;
  companyNotificationSettingsList: Array<CompanyNotificationSettingsInterface>;
}

export interface PersistFirmNotificationSettingsResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetProcessingTimelineSettingsRequestInterface {
  companyId: number;
}

export interface GetProcessingTimelineSettingsResponseInterface {
  processingTimelineSettingList: Array<ProcessingTimelineSettingInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PersistProcessingTimelineSettingsRequestInterface {
  companyId: number;
  processingTimelineSettingList: Array<ProcessingTimelineSettingInterface>;
}

export interface PersistProcessingTimelineSettingsResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ProcessingTimelineSettingInterface {
  processingTimeline: number;
  timelineChangeType: TimelineChangeTypeEnum;
  effectiveDate: string;
  isDeleted: boolean;
  isAdded: boolean;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

export class CompanySettingsAccessService {
  persistCompanySettings(
    request: PersistCompanySettingsRequestInterface
  ): Promise<PersistCompanySettingsResponseInterface> {
    return Post('/AppCoreCompanySettingsAccess/persistCompanySettings', request);
  }

  getCompanySettings(request: GetCompanySettingsRequestInterface): Promise<GetCompanySettingsResponseInterface> {
    return Post('/AppCoreCompanySettingsAccess/getCompanySettings', request);
  }

  persistLogoId(request: PersistLogoIdRequestInterface): Promise<PersistLogoIdResponseInterface> {
    return Post('/AppCoreCompanySettingsAccess/persistLogoId', request);
  }

  getCompanyNotificationSettings(
    request: GetCompanyNotificationSettingsRequestInterface
  ): Promise<GetCompanyNotificationSettingsResponseInterface> {
    return Post('/AppCoreCompanySettingsAccess/getCompanyNotificationSettings', request);
  }

  persistCompanyNotificationSettings(
    request: PersistCompanyNotificationSettingsRequestInterface
  ): Promise<PersistCompanyNotificationSettingsResponseInterface> {
    return Post('/AppCoreCompanySettingsAccess/persistCompanyNotificationSettings', request);
  }

  getFirmNotificationSettings(
    request: GetFirmNotificationSettingsRequestInterface
  ): Promise<GetFirmNotificationSettingsResponseInterface> {
    return Post('/AppCoreCompanySettingsAccess/getFirmNotificationSettings', request);
  }

  persistFirmNotificationSettings(
    request: PersistFirmNotificationSettingsRequestInterface
  ): Promise<PersistFirmNotificationSettingsResponseInterface> {
    return Post('/AppCoreCompanySettingsAccess/persistFirmNotificationSettings', request);
  }

  getProcessingTimelineSettings(
    request: GetProcessingTimelineSettingsRequestInterface
  ): Promise<GetProcessingTimelineSettingsResponseInterface> {
    return Post('/AppCoreCompanySettingsAccess/getProcessingTimelineSettings', request);
  }

  persistProcessingTimelineSettings(
    request: PersistProcessingTimelineSettingsRequestInterface
  ): Promise<PersistProcessingTimelineSettingsResponseInterface> {
    return Post('/AppCoreCompanySettingsAccess/persistProcessingTimelineSettings', request);
  }
}

export default new CompanySettingsAccessService();
